import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
export function FinalCtaSection() {
  return <section className="w-full bg-forest-800 px-6 py-14 sm:py-20" aria-labelledby="cierre-titulo" data-id="element-62" data-mp="3lwj6mhkdn18o">
      <div className="mx-auto max-w-3xl text-center" data-id="element-63" data-mp="3qrgcjfmd0uhc">
        <h2 id="cierre-titulo" className="font-display text-3xl font-bold leading-tight text-cream-50 sm:text-5xl" data-id="element-64" data-mp="3vrkwjfmh87cb">
          Tu acceso completo te espera
        </h2>

        <blockquote className="mt-6 font-display text-xl italic leading-relaxed text-cream-100/80 sm:text-2xl" data-id="element-65" data-mp="333p2kioaktj8">
          “La próxima clase que des, podés entrar sabiendo que tenés la respuesta técnica para cualquier
          pregunta sobre medición, control o tecnología 4.0. Y podés dedicar tu energía a enseñar, no a
          buscar.”
        </blockquote>

        <div className="mt-8 rounded-3xl border border-cream-100/15 bg-white/[0.06] p-7 sm:p-9" data-id="element-66" data-mp="2fe47x2is07u4">
          <p className="text-base text-cream-100/75" data-id="element-67" data-mp="2kbmjz1s3b36c">
            Kit Instrumentación Industrial — 6 Volúmenes + 5 Bonos + 510 Páginas
          </p>
          <p className="mt-5 flex items-baseline justify-center gap-4" data-id="element-68" data-mp="28cdpjsm8gifg">
            <span className="font-display text-2xl text-cream-100/45 line-through" data-id="element-69" data-mp="28f9pfmhn5h6j">$97 USD</span>
            <span className="font-display text-5xl font-bold text-cream-50 sm:text-6xl" data-id="element-70" data-mp="23jubkujmvla4">$19 USD</span>
          </p>
          <p className="mx-auto mt-5 max-w-md text-base text-cream-100/70" data-id="element-71" data-mp="1ul8wxaha8qem">
            Pago único. Acceso en 5 minutos. Incluye los 6 volúmenes técnicos + los 5 bonos sin costo
            adicional.
          </p>
          <CtaButton className="mt-8" href={CHECKOUT_URL} source="cierre" data-id="element-72" data-mp="1kmt6zatzrn6p" />
          <div className="mt-6 flex flex-col items-center justify-center gap-3 text-sm text-cream-100/65 sm:flex-row sm:gap-5" data-id="element-73" data-mp="1fo9ib2o0jxan">
            <span className="flex items-center gap-2" data-id="element-74" data-mp="3f1m0937ek1vh">
              <span className="flex" aria-hidden="true" data-id="element-75" data-mp="3eyzsb2glnkcq">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" data-id="element-76" data-mp="3a3282l27ttuo" />)}
              </span>
              4.9/5 — Calificación de docentes
            </span>
            <span className="hidden h-4 w-px bg-cream-100/20 sm:block" aria-hidden="true" data-id="element-77" data-mp="1d4lisew7trd3" />
            <span className="flex items-center gap-2" data-id="element-78" data-mp="yfyqlclhp54g">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="13e0a1ymtv6gg" />
              Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}